module.exports = __webpack_public_path__ + "static/wobble-44f1b2712ab055c7f78eaf6efe1f405d.svg";